// extracted by mini-css-extract-plugin
export default {"link":"Link_link__nWP2w","second":"Link_second__cF2Dz","default":"Link_default__IEwaQ"};